import { useTranslation } from "react-i18next";
import FormSection from "../../../../common/components/functional/formSection/FormSection";
import AddButton from "../../../../common/components/functional/addButton/AddButton";
import { Box, Grid, Typography } from "@mui/material";
import { Union } from "../unionsApi";
import {
  gridUnionNameStyles,
  gridUnionNumberStyles,
  headerStyles,
} from "../unionsStyles";
interface Props {
  union: Union;
  setSelectedUnionId: (id: string) => void;
  handleSave: (afterSave: string) => Promise<boolean>;
}

const UnionLocalTradeUnions = ({
  union,
  setSelectedUnionId,
  handleSave,
}: Props) => {
  const { t } = useTranslation("settings");

  const sortedLocalUnions =
    union?.localUnions?.slice().sort((a, b) => {
      if (
        a.tradeUnionNumber === undefined &&
        b.tradeUnionNumber === undefined
      ) {
        return 0;
      } else if (
        a.tradeUnionNumber === undefined ||
        a.tradeUnionNumber === null
      ) {
        return -1;
      } else if (
        b.tradeUnionNumber === undefined ||
        b.tradeUnionNumber === null
      ) {
        return 1;
      } else {
        // Assuming tradeUnionNumber is a string since we're using localeCompare
        return a.tradeUnionNumber.localeCompare(b.tradeUnionNumber);
      }
    }) ?? [];

  const handleAddNew = async () => {
    const isSuccess = await handleSave("continue");
    isSuccess && setSelectedUnionId("newLocal");
  };

  return (
    <FormSection title={t("settings:unionLocalTradeUnions")}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          margin: "20px",
          width: "100%",
        }}
      >
        {sortedLocalUnions?.length > 0 && (
          <Grid
            container
            spacing={2}
            style={{ paddingLeft: "10px", width: "60%" }}
          >
            <Grid item xs={10} style={headerStyles}>
              <Typography variant="subtitle1">{t("localUnionName")}</Typography>
            </Grid>
            <Grid item xs={2} style={headerStyles}>
              <Typography variant="subtitle1">
                {t("localUnionNumber")}
              </Typography>
            </Grid>
            {sortedLocalUnions?.map((localUnion, index) => (
              <Grid container key={index} style={{ flexWrap: "nowrap" }}>
                <Grid item xs={10} style={gridUnionNameStyles}>
                  <Typography
                    onClick={() =>
                      localUnion?.id && setSelectedUnionId(localUnion.id)
                    }
                  >
                    {localUnion.name}
                  </Typography>
                </Grid>
                <Grid item xs={2} style={gridUnionNumberStyles}>
                  <Typography>{localUnion.tradeUnionNumber}</Typography>
                </Grid>
              </Grid>
            ))}
          </Grid>
        )}
        <Box
          sx={{
            marginLeft: "10px",
          }}
        >
          <AddButton
            variant="outlined"
            sx={{
              margin: "16px 0px 32px 0px",
              alignSelf: "flex-start",
              background: "#f7f7f9",
              height: "36px",
              borderRadius: "18px",
              borderColor: "rgba(74, 29, 156, 0.5)",
            }}
            label={t("addNewLocalUnion")}
            onClick={() => handleAddNew()}
          />
        </Box>
      </Box>
    </FormSection>
  );
};

export default UnionLocalTradeUnions;
